<template>
  <span
    :data-tooltip="text"
    :data-flow="flow"
    class="custom-tooltip"
  />
</template>

<script>
export default {
  name: 'CustomTooltip',
  props: {
    text: {
      type: String,
      default: '',
    },
    flow: {
      type: String,
      default: 'top',
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-tooltip {
  position: absolute;
  cursor: pointer;
  margin-left: 123px;
  margin-top: -38px;
}
.custom-tooltip:before,
.custom-tooltip:after {
  line-height: 1;
  font-size: .9em;
  position: absolute;
  box-sizing: border-box;
  display: block;
}
.custom-tooltip:before {
  content: "";
  border: 5px solid transparent;
  z-index: 100;
  left: -62px !important;
}
.custom-tooltip:after {
  content: attr(data-tooltip);
  text-align: center;
  min-width: 3em;
  max-width: 21em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 6px 8px;
  border-radius: 3px;
  background: #ff5050;
  color: #FFFFFF;
  z-index: 99;
}
.custom-tooltip:hover:before,
.custom-tooltip:hover:after {
  display: block;
  opacity: 1;
}
.custom-tooltip:not([data-flow])::before,
.custom-tooltip[data-flow="top"]::before {
  bottom: 100%;
  border-bottom-width: 0;
  border-top-color: #ff5050;
}
.custom-tooltip:not([data-flow])::after,
.custom-tooltip[data-flow="top"]::after {
  bottom: calc(100% + 5px);
}
.custom-tooltip:not([data-flow])::before, [tooltip]:not([data-flow])::after,
.custom-tooltip[data-flow="top"]::before,
.custom-tooltip[data-flow="top"]::after {
  left: 50%;
  -webkit-transform: translate(-50%, -4px);
          transform: translate(-50%, -4px);
}
.custom-tooltip[data-flow="bottom"]::before {
  top: 100%;
  border-top-width: 0;
  border-bottom-color: #ff5050;
}
.custom-tooltip[data-flow="bottom"]::after {
  top: calc(100% + 5px);
}
.custom-tooltip[data-flow="bottom"]::before, .custom-tooltip[data-flow="bottom"]::after {
  left: 50%;
  -webkit-transform: translate(-50%, 8px);
          transform: translate(-50%, 8px);
}
.custom-tooltip[data-flow="left"]::before {
  top: 50%;
  border-right-width: 0;
  border-left-color: #ff5050;
  left: calc(0em - 5px);
  -webkit-transform: translate(-8px, -50%);
          transform: translate(-8px, -50%);
}
.custom-tooltip[data-flow="left"]::after {
  top: 50%;
  right: calc(100% + 5px);
  -webkit-transform: translate(-8px, -50%);
          transform: translate(-8px, -50%);
}
.custom-tooltip[data-flow="right"]::before {
  top: 50%;
  border-left-width: 0;
  border-right-color: #ff5050;
  right: calc(0em - 5px);
  -webkit-transform: translate(8px, -50%);
          transform: translate(8px, -50%);
}
.custom-tooltip[data-flow="right"]::after {
  top: 50%;
  left: calc(100% + 5px);
  -webkit-transform: translate(8px, -50%);
          transform: translate(8px, -50%);
}
[data-tooltip=""]::after, [data-tooltip=""]::before {
  display: none !important;
}
</style>
